<div class="flex flex-col">
	<div class="w-fit mb-2">
		<app-radio-group
			type="compact"
			[items]="mortgageeTypeOptions"
			[ngModel]="selectedMortgageeType"
			(ngModelChange)="setSelectedMortgageeType($event)"
		></app-radio-group>
	</div>

	<app-lender-search-input
		*ngIf="selectedMortgageeType != mortgageeTypes.PRIVATE_LENDER"
		[mortgageeType]="selectedMortgageeType"
		(onSelected)="onFinancialInstitutionSelected($event)"
	></app-lender-search-input>

	<ng-container *ngIf="selectedMortgageeType === mortgageeTypes.PRIVATE_LENDER">
		<div class="my-4">Search to add a private lender</div>
		<app-client-search
			*ngIf="selectedMortgageeType == mortgageeTypes.PRIVATE_LENDER"
			[searchType]="SearchType.CardsAndPeople"
			createButtonLabel="Create new lender"
			placeholder="Search to add a lender"
			(clientSelected)="onClientSelected($event)"
			(add)="onAddClient($event)"
		></app-client-search>
	</ng-container>
</div>
